// Checkout linking is authorized. Stripe payment setup has been confirmed in Impul.
export const PREVIEW_MODE: boolean = false;
export const PAYMENTS_ENABLED: boolean = true;

export const CHECKOUT_URL =
  "https://hockey-class-ready.impultienda.ar/checkout";

export const PRODUCT_NAME = "FloorHockeyClassReady — 12 Beginner Lessons";
